var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { isErrorHTTP } from 'boost-api/APIRestClient';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { router } from '../router/BoostPortalRouter';
import { BoostPortalMemberPrivatelySponsoredProgress } from '../components/BoostPortalMemberPrivatelySponsoredProgress';
import { BoostButton } from '../components/common/BoostButton';
import { BoostPortalChooseDepartment } from '../components/BoostPortalChooseDepartment';
import { BoostPortalChooseMembership } from '../components/BoostPortalChooseMembership';
import { BoostPortalLookupSponsor } from '../components/BoostPortalLookupSponsor';
import { BoostPortalPersonalInformation, } from '../components/BoostPortalPersonalInformation';
import { BoostPortalValidateSponsorCode } from '../components/BoostPortalValidateSponsorCode';
import { BoostStepIndicator, } from '../components/common/BoostStepIndicator';
import { BoostPortalHeader } from '../components/BoostPortalHeader';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import { TrackingFactorySingleton } from '../tracking/TrackingFactorySingleton';
import { TrackingEvent } from '../tracking/TrackingEvent';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
import { BoostPortalNavigationSteps } from '../enums/BoostPortalNavigationSteps';
import { BoostSponsorController } from '../controllers/BoostSponsorController';
let BoostPortalRegisterMemberPrivatelySponsoredView = class BoostPortalRegisterMemberPrivatelySponsoredView extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    static get is() {
        return 'boost-portal-register-member-privately-sponsored-view';
    }
    static get styles() {
        return css `
            :host {
                width: 90%;
            }
        `;
    }
    constructor() {
        super();
        this.isValidSponsorCode = false;
        this.memberships = [];
        this.memberExists = false;
        this.meetsMinimumAge = true;
        this.sponsorController = new BoostSponsorController(this);
        this.updateComplete.then(() => __awaiter(this, void 0, void 0, function* () {
            const urlParameters = new URLSearchParams(location.search);
            const memberCreated = urlParameters.get('success');
            if (memberCreated) {
                this.memberCreated = memberCreated === 'true';
            }
        }));
    }
    /** @override */ render() {
        return html `
            <boost-portal-header .viewLoginButton="${false}"></boost-portal-header>
            ${this.sponsorController.currentStep === BoostPortalNavigationSteps.DEPARTMENT
            ? html ` <p>${this.boostTranslateOutputHtml('sponsor-member-setup')}</p> `
            : nothing}
            <boost-step-indicator
                currentStep="${this.sponsorController.currentStep}"
                .steps="${this._getSteps()}"
                @currentStep-changed="${(event) => {
            this.sponsorController.setCurrentStep(event.detail.currentStep);
        }}"
            ></boost-step-indicator>

            ${this._showViewForCurrentStep()}
        `;
    }
    _createMember(event) {
        return __awaiter(this, void 0, void 0, function* () {
            window.dispatchEvent(new CustomEvent('validateFields', { bubbles: true, composed: true }));
            const buttonElement = event.srcElement;
            if (buttonElement.disabled) {
                return;
            }
            if (!this.memberInformation ||
                !this.sponsorController.isValidMemberInformation() ||
                !this.selectedDepartmentId ||
                !this.selectedMembershipId) {
                return;
            }
            this.memberInformation.is_privately_sponsored = true;
            this.memberInformation.departmentId = this.selectedDepartmentId;
            this.memberInformation.membershipId = this.selectedMembershipId;
            this.memberInformation.netsCallbackUrl =
                router.baseUrl + this.centerShort + '/avtalegiro?departmentId=' + this.selectedDepartmentId;
            this.requestUpdate('memberInformation');
            buttonElement.setLoading(true);
            const createdMemberResult = yield MembersignupAPI.postV1BoostsignupMember(this.memberInformation);
            buttonElement.setLoading(false);
            if (isErrorHTTP(createdMemberResult)) {
                if (createdMemberResult.error.http_status === 409) {
                    this.memberExists = true;
                }
                else {
                    SnackBar.pushError(createdMemberResult.error);
                }
                return;
            }
            this.dispatch(BoostPortalStore.Actions.SetMemberInformation(createdMemberResult));
            TrackingFactorySingleton.asyncTracker((tracker) => tracker.completedEvent(TrackingEvent.PersonalInformationFilled));
            this.sponsorController.setMemberInformation(createdMemberResult);
            this.sponsorController.setCurrentStep(BoostPortalNavigationSteps.SPONSOR);
        });
    }
    _getSteps() {
        const currentStep = this.sponsorController.currentStep;
        const steps = [
            {
                title: this.boostTranslate('agreement'),
                isActive: currentStep === BoostPortalNavigationSteps.DEPARTMENT,
                subtitle: '',
            },
            {
                title: this.boostTranslate('personalia'),
                isActive: currentStep === BoostPortalNavigationSteps.INFORMATION,
                subtitle: '',
            },
            {
                title: this.boostTranslate('payment-person'),
                isActive: currentStep === BoostPortalNavigationSteps.SPONSOR,
                subtitle: '',
            },
        ];
        if (this.loggedInProfile) {
            steps.splice(1, 1);
        }
        return steps;
    }
    _showViewForCurrentStep() {
        const currentStep = this.sponsorController.currentStep;
        switch (currentStep) {
            case BoostPortalNavigationSteps.DEPARTMENT:
                return this._renderDepartmentAndMembershipView();
            case BoostPortalNavigationSteps.INFORMATION:
                return this._renderInformationView();
            case BoostPortalNavigationSteps.SPONSOR:
                return this._renderSponsorView();
            case BoostPortalNavigationSteps.SUCCESS:
                return this._renderSuccessView();
        }
    }
    _renderDepartmentAndMembershipView() {
        var _a, _b, _c, _d;
        return html `
            <boost-portal-choose-department></boost-portal-choose-department>
            ${this.selectedDepartmentId
            ? html `<boost-portal-choose-membership is-sponsor></boost-portal-choose-membership>`
            : html `<div style="padding-bottom:16px;"></div>`}
            <div>
                ${!this.sponsorController.underageMemberMeetsShorttermRequirements &&
            ((_a = this.sponsorController.getSelectedMembership(this.selectedMembershipId, this.memberships)) === null || _a === void 0 ? void 0 : _a.temporary)
            ? html `
                          <status-container type="info">
                              ${this.boostTranslateOutputHtml('short-term-membership-under-age', {
                age: (_d = (_c = (_b = this.center) === null || _b === void 0 ? void 0 : _b.short_term_minimum_age) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '18',
            })}
                          </status-container>
                      `
            : html `<boost-button
                          type="submit"
                          name="${this.boostTranslate('next-button')}"
                          @click="${() => this._changeStepToInformationOrSponsor()}"
                          ?disabled="${this._isNextButtonDisabled()}"
                          width-full
                      ></boost-button>`}
            </div>
        `;
    }
    _renderInformationView() {
        var _a, _b, _c;
        return html `<boost-portal-member-privately-sponsored-progress></boost-portal-member-privately-sponsored-progress>

            <boost-portal-personal-information
                isSponsor
                @memberPhoneNumber-changed="${() => (this.memberExists = false)}"
                @meetsMinimumAge="${(event) => (this.meetsMinimumAge = event.detail.value)}"
                @memberExists-changed="${(event) => (this.memberExists = event.detail.memberExists)}"
            >
            </boost-portal-personal-information>

            ${this.memberExists
            ? html `
                      <boost-status-container type="info">
                          ${this.sponsorController.isLoggedIn &&
                this.sponsorController.loggedInProfileHasActiveMembership
                ? 'Du har allerede et aktivt medlemskap og kan ikke melde deg inn på nytt'
                : html ` ${this.boostTranslateOutputHtml('earlier-member', {
                    url: router.baseUrl + this.centerShort + '/login',
                })}`}
                      </boost-status-container>
                  `
            : html `
                      ${!this.meetsMinimumAge
                ? html `<boost-status-container type="info">
                                ${this.boostTranslateOutputHtml('under-age', {
                    age: (_c = (_b = (_a = this.center) === null || _a === void 0 ? void 0 : _a.minimum_age) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '18',
                })}
                            </boost-status-container>`
                : html `<div>
                                <boost-button
                                    type="submit"
                                    name="${this.boostTranslate('next-button')}"
                                    @click="${(event) => this._createMember(event)}"
                                    ?disabled="${!this.sponsorController.isValidMemberInformation()}"
                                    width-full
                                ></boost-button>
                            </div>`}
                  `} `;
    }
    _renderSponsorView() {
        return html ` <boost-portal-member-privately-sponsored-progress></boost-portal-member-privately-sponsored-progress>
            <boost-portal-lookup-sponsor></boost-portal-lookup-sponsor>`;
    }
    _renderSuccessView() {
        return html ` ${this.memberCreated
            ? html `
                  <boost-status type="success">
                      ${this.boostTranslateOutputHtml('sponsor-member-created-info')}
                  </boost-status>
              `
            : html `
                  <boost-status type="danger">
                      ${this.boostTranslate('spons-status-container-danger')}
                  </boost-status>
              `}`;
    }
    _changeStepToInformationOrSponsor() {
        if (this.loggedInProfile) {
            this.sponsorController.setCurrentStep(BoostPortalNavigationSteps.SPONSOR);
            return;
        }
        this.sponsorController.setCurrentStep(BoostPortalNavigationSteps.INFORMATION);
    }
    _isNextButtonDisabled() {
        return !this.selectedDepartmentId || !this.selectedMembershipId;
    }
    _updateMember(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const buttonElement = event.srcElement;
            if (buttonElement.disabled) {
                return;
            }
            if (!this.memberInformation) {
                return;
            }
            if (!this.sponsorController.isValidMemberInformation() && this.isValidSponsorCode) {
                return;
            }
            if (!this.sponsorCode) {
                return;
            }
            buttonElement.setLoading(true);
            const updateMemberResult = yield MembersignupAPI.postV1BoostsignupSponsorUsingSponsorcode(this.sponsorCode, {
                departmentId: this.memberInformation.departmentId,
                memberId: this.memberInformation.memberId,
                contractId: this.memberInformation.contractId,
            });
            buttonElement.setLoading(false);
            if (isErrorHTTP(updateMemberResult)) {
                SnackBar.pushError(updateMemberResult.error);
                return;
            }
            TrackingFactorySingleton.asyncTracker((tracker) => tracker.completedEvent(TrackingEvent.SponsorConfirmed));
            window.location.replace(window.location.href + '?success=true');
        });
    }
    _redirectToMemberRoute() {
        if (!this.sponsorController.redirectToMemberRoute) {
            return;
        }
        window.location.replace(`${this.centerShort}/member?membershipId=${this.selectedMembershipId}&departmentId=${this.selectedDepartmentId}`);
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'memberships':
                    this.sponsorController.setMemberships(this.memberships);
                    break;
                case 'loggedInProfile':
                    this.sponsorController.setLoggedInProfile(this.loggedInProfile);
                    break;
                case 'selectedDepartmentId':
                    this.sponsorController.setSelectedDepartmentId(this.selectedDepartmentId);
                    break;
                case 'selectedMembershipId':
                    this.sponsorController.setSelectedMembershipId(this.selectedMembershipId);
                    this._redirectToMemberRoute();
                    break;
                case 'session':
                    this.sponsorController.setSession(this.session);
                    break;
                case 'center':
                    this.sponsorController.setCenter(this.center);
                    this._redirectToMemberRoute();
                    break;
                case 'centerShort':
                    this.sponsorController.setCenterShort(this.centerShort);
                    break;
                case 'memberInformation':
                    this.sponsorController.setMemberInformation(this.memberInformation);
                    break;
            }
        });
        super.updated(changedProperties);
    }
};
BoostPortalRegisterMemberPrivatelySponsoredView._deps = [
    BoostButton,
    BoostStepIndicator,
    BoostPortalChooseDepartment,
    BoostPortalChooseMembership,
    BoostPortalPersonalInformation,
    BoostPortalMemberPrivatelySponsoredProgress,
    BoostPortalValidateSponsorCode,
    BoostPortalLookupSponsor,
    BoostPortalHeader,
];
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "centerShort", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('center')),
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "center", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "isValidSponsorCode", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "memberCreated", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberInformation')),
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "memberInformation", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "selectedDepartmentId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedMembershipId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "selectedMembershipId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('sponsorCode')),
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "sponsorCode", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberships')),
    state(),
    __metadata("design:type", Array)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "memberships", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "memberExists", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('session')),
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "session", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('loggedInProfile')),
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "loggedInProfile", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "meetsMinimumAge", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberPrivatelySponsoredView.prototype, "sponsorController", void 0);
BoostPortalRegisterMemberPrivatelySponsoredView = __decorate([
    customElement(BoostPortalRegisterMemberPrivatelySponsoredView.is),
    __metadata("design:paramtypes", [])
], BoostPortalRegisterMemberPrivatelySponsoredView);
export { BoostPortalRegisterMemberPrivatelySponsoredView };
